import { More, MoreSquare } from "iconsax-react";
import React, { ReactNode } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { cn } from "src/lib/utils";

interface TableActionDropdownProps {
  onViewDetail?: () => void;
  currentActiveStatus?: "active" | "inactive";
  onToggleActiveStatus?: () => void;
  onEdit?: () => void;
  onDownloadQR?: () => void;
  onRemove?: () => void;
  onAdd?: () => void;
  addLabel?: string;
  removeLabel?: string;
  className?: string;
  withoutOutline?: boolean;
  otherPositiveAction?: () => void;
  otherPositiveActionTitle?: string;
  otherPositiveAction2?: () => void;
  otherPositiveAction2Title?: string;
  children?: ReactNode;
  featureName?: string;
}

const TableActionDropdown: React.FC<TableActionDropdownProps> = ({
  onViewDetail,
  currentActiveStatus,
  onToggleActiveStatus,
  onEdit,
  onDownloadQR,
  onRemove,
  onAdd,
  addLabel,
  removeLabel = "Remove",
  className,
  withoutOutline,
  otherPositiveAction,
  otherPositiveActionTitle,
  otherPositiveAction2,
  otherPositiveAction2Title,
  children,
  featureName,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={className}>
        {!withoutOutline ? (
          <MoreSquare className="text-darkRed-60" />
        ) : (
          <More className="text-darkRed-60" />
        )}
      </DropdownMenuTrigger>

      <DropdownMenuContent className="text-darkIndicator-40">
        {otherPositiveAction && (
          <DropdownMenuItem
            className="text-indicator-success hover:!text-indicator-success"
            onClick={otherPositiveAction}
          >
            {otherPositiveActionTitle}
          </DropdownMenuItem>
        )}
        {onViewDetail && (
          <DropdownMenuItem onClick={onViewDetail}>
            View Detail
          </DropdownMenuItem>
        )}
        {otherPositiveAction2 && (
          <DropdownMenuItem
            className="text-[#502828]"
            onClick={otherPositiveAction2}
          >
            {otherPositiveAction2Title}
          </DropdownMenuItem>
        )}
        {onAdd && (
          <DropdownMenuItem onClick={onAdd}>{addLabel}</DropdownMenuItem>
        )}
        {onEdit && <DropdownMenuItem onClick={onEdit}>Edit</DropdownMenuItem>}
        {onToggleActiveStatus && (
          <DropdownMenuItem
            className={cn(
              currentActiveStatus === "active"
                ? "text-blueIndicator-50"
                : "text-darkRed-70"
            )}
            onClick={onToggleActiveStatus}
          >
            {currentActiveStatus === "active" ? "Deactivate" : "Activate"}{" "}
            {featureName}
          </DropdownMenuItem>
        )}
        {onDownloadQR && (
          <DropdownMenuItem onClick={onDownloadQR}>
            Download QR Code
          </DropdownMenuItem>
        )}
        {onRemove && (
          <DropdownMenuItem
            className="text-redIndicator-50 hover:!text-redIndicator-50"
            onClick={onRemove}
          >
            {removeLabel}
          </DropdownMenuItem>
        )}

        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TableActionDropdown;
